import React from "react";
import mockupHtml from "@/pages/farmMockupHtml";

export default function FarmMockups() {
  return (
    <iframe
      title="Shift Farm Mockups"
      srcDoc={mockupHtml}
      style={{ width: "100vw", height: "100vh", border: 0, display: "block" }}
      data-testid="farm-mockups-frame"
    />
  );
}
